import React, { useState, useEffect } from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { View, Text, StyleSheet, Linking, Platform, Dimensions, ScrollView } from 'react-native';
import MapView from 'react-native-maps';
import openMap from 'react-native-open-maps';
import PropTypes from 'prop-types';
import { MaterialCommunityIcons, MaterialIcons, FontAwesome } from '@expo/vector-icons';
import Config from 'react-native-config';

import Constants from '../Constants';
import DetailCard from './DetailCard';

const containerStyle = {
  width: Dimensions.get('window'),
  height: '500px',
};

function formatPhoneNumber(phoneNumberString) {
  const cleaned = `${phoneNumberString}`.replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return null;
}

function formatWaitTime(waitTime) {
  const hour = (waitTime / 60).toFixed(0);
  const minute = waitTime % 60;

  const timeString = hour > 0 ? ` ${hour} h` : '';

  return `${timeString} ${minute} min`;
}

export default function HospitalDetails({ route }) {
  const [hospitalInfo, setHospitalInfo] = useState(null);
  const [isPortrait, setIsPortrait] = useState(false);
  const { id } = route.params;

  useEffect(() => {
    const { width, height } = Dimensions.get('window');
    setIsPortrait(width <= height);
  }, []);

  useEffect(() => {
    const eventSubscription = Dimensions.addEventListener('change', (dimensions) => {
      const { width, height } = dimensions.window;
      setIsPortrait(width <= height);
    });
    return () => {
      eventSubscription.remove();
    };
  }, []);

  useEffect(() => {
    fetch(`${Constants.apiUrl}/api/${id}`)
      .then((res) => res.json())
      .then((hospital) => setHospitalInfo(hospital))
      .catch((err) => console.error(err));
  }, [id]);

  //week10
  if (Platform.OS === 'ios' || Platform.OS === 'android') {
    return (
      <View style={{ flex: 1 }}>
        {!hospitalInfo ? (
          <Text>Loading....</Text>
        ) : (
          <View style={[styles.container, { flexDirection: isPortrait ? 'column' : 'row' }]}>
            <MapView
              style={{
                flex: 1,
              }}
              provider="google"
              showsUserLocation
              followUserLocation
              showsPointsOfInterest={false}
              region={{
                latitude: hospitalInfo.latitude,
                longitude: hospitalInfo.longitude,
                latitudeDelta: 0.02,
                longitudeDelta: 0.02,
              }}
            >
              <MapView.Marker
                title={hospitalInfo.name}
                description="HOSPITAL"
                coordinate={{ latitude: hospitalInfo.latitude, longitude: hospitalInfo.longitude }}
              />
            </MapView>
            <ScrollView
              style={{ flex: 1, paddingLeft: isPortrait ? 0 : 15, paddingTop: isPortrait ? 15 : 0 }}
            >
              <View style={styles.bedContainer}>
                <View style={styles.bedIcons}>
                  <FontAwesome name="hourglass" size={24} color="black" />
                  <Text>Wait time:</Text>
                  <Text>{formatWaitTime(hospitalInfo.wait_time)}</Text>
                </View>
                <View style={styles.bedIcons}>
                  <MaterialCommunityIcons name="bed-empty" size={30} color="black" />
                  <Text>Available:</Text>
                  <Text>{hospitalInfo.available_beds}</Text>
                </View>
                <View style={styles.bedIcons}>
                  <MaterialCommunityIcons name="bed" size={30} color="black" />
                  <Text>Total:</Text>
                  <Text>{hospitalInfo.total_beds}</Text>
                </View>
              </View>
              <DetailCard onPress={() => Linking.openURL(`tel:${hospitalInfo.phone}`)}>
                <View style={styles.card}>
                  <FontAwesome style={styles.infoIcon} name="phone" size={35} color="black" />
                  <Text style={styles.infoTxt}>{formatPhoneNumber(hospitalInfo.phone)}</Text>
                </View>
              </DetailCard>
              <DetailCard
                onPress={() =>
                  openMap({
                    provider: 'google',
                    query: hospitalInfo.address,
                  })
                }
              >
                <View style={styles.card}>
                  <MaterialIcons
                    name="add-location"
                    size={35}
                    color="black"
                    style={styles.infoIcon}
                  />
                  <Text style={styles.infoTxt}>{hospitalInfo.address}</Text>
                </View>
              </DetailCard>
            </ScrollView>
          </View>
        )}
      </View>
    );
  }
  // eslint-disable-next-line no-else-return
  else {
    return (
      <View style={{ flex: 1 }}>
        {!hospitalInfo ? (
          <Text>Loading....</Text>
        ) : (
          <View style={[styles.container, { flexDirection: isPortrait ? 'column' : 'row' }]}>
            <ScrollView
              style={{ flex: 1, paddingLeft: isPortrait ? 0 : 15, paddingTop: isPortrait ? 15 : 0 }}
            >
              <LoadScript googleMapsApiKey={process.env.API_KEY}>
                <GoogleMap
                  mapContainerStyle={containerStyle}
                  center={{ lat: hospitalInfo.latitude, lng: hospitalInfo.longitude }}
                  zoom={15}
                >
                  <Marker position={{ lat: hospitalInfo.latitude, lng: hospitalInfo.longitude }} />
                </GoogleMap>
              </LoadScript>

              <View style={styles.bedContainer}>
                <View style={styles.bedIcons}>
                  <FontAwesome name="hourglass" size={24} color="black" />
                  <Text>Wait time:</Text>
                  <Text>{formatWaitTime(hospitalInfo.wait_time)}</Text>
                </View>
                <View style={styles.bedIcons}>
                  <MaterialCommunityIcons name="bed-empty" size={30} color="black" />
                  <Text>Available:</Text>
                  <Text>{hospitalInfo.available_beds}</Text>
                </View>
                <View style={styles.bedIcons}>
                  <MaterialCommunityIcons name="bed" size={30} color="black" />
                  <Text>Total:</Text>
                  <Text>{hospitalInfo.total_beds}</Text>
                </View>
              </View>
              <DetailCard onPress={() => Linking.openURL(`tel:${hospitalInfo.phone}`)}>
                <View style={styles.card}>
                  <FontAwesome style={styles.infoIcon} name="phone" size={35} color="black" />
                  <Text style={styles.infoTxt}>{formatPhoneNumber(hospitalInfo.phone)}</Text>
                </View>
              </DetailCard>
              <DetailCard
                onPress={() =>
                  openMap({
                    provider: 'google',
                    query: hospitalInfo.address,
                  })
                }
              >
                <View style={styles.card}>
                  <MaterialIcons
                    name="add-location"
                    size={35}
                    color="black"
                    style={styles.infoIcon}
                  />
                  <Text style={styles.infoTxt}>{hospitalInfo.address}</Text>
                </View>
              </DetailCard>
            </ScrollView>
          </View>
        )}
      </View>
    );
  }
}

HospitalDetails.propTypes = {
  route: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    margin: 20,
  },
  bedContainer: {
    flexDirection: 'row',
    backgroundColor: 'white',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    padding: 20,
    borderRadius: 10,
  },
  bedIcons: {
    alignItems: 'center',
  },
  infoIcon: {
    marginLeft: '8%',
  },
  infoTxt: {
    marginLeft: '10%',
    fontSize: 20,
    flexShrink: 1,
  },
  card: {
    backgroundColor: '#fff',
    flexDirection: 'row',
    borderRadius: 10,
    paddingVertical: 30,
    paddingHorizontal: 20,
    ...Platform.select({
      ios: {
        shadowColor: '#000',
        shadowOffset: {
          width: 0,
          height: 1,
        },
        shadowOpacity: 0.2,
        shadowRadius: 1.41,
      },
      android: {
        elevation: 2,
      },
    }),
  },
});
